// extracted by mini-css-extract-plugin
export default {"box":"imageslider_box__ugL2G","imgSlider":"imageslider_imgSlider__JDaDA","img":"imageslider_img__A-yvA","btn":"imageslider_btn__u3Gfv","smallBtn":"imageslider_smallBtn__VJnho"};